enum ScheduleType {
    department = 0,
    individual
}

export default ScheduleType;